/**
 * seskupuje prvky listu dle některé vlastnosti
 * @param {Array} list list k seskupení
 * @param {Function} keyGetter vlastnost
 */
export function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach(item => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return Array.from(map);
}

/**
 * seřadí list podle atributu key, od nejmenšího po největší
 * @param {Array} list list k setřídění
 */
export function orderByKey(list) {
  return list.sort((a, b) => (a.key > b.key ? 1 : b.key > a.key ? -1 : 0));
}

/**
 * seřadí list podle atributu key, od největší po nejmenší
 * @param {Array} list list k setřídění
 */
export function orderByKeyDescending(list) {
  return list.sort((a, b) => (a.key < b.key ? 1 : b.key < a.key ? -1 : 0));
}
